import React, { useState, FocusEvent } from 'react';
import { Field, useFormikContext } from 'formik';
import { FormControl, FormHelperText } from '@mui/material';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './phone-input.css';

type GenericObject = { [key: string]: any };

export type PhoneInputFieldProps = {
    country?: string;
    name: string;
    specialLabel?: string;
    id?: string;
    required?: boolean;
};

const PhoneInputField = ({ country, name, specialLabel, id }: PhoneInputFieldProps) => {
    const { values, errors, touched, setFieldValue, setTouched } = useFormikContext<GenericObject>();
    const [valueLength, setValueLength] = useState<number>(0);
    const [spaceCount, setSpaceCount] = useState<number>(0);
    const [dialCode, setDialCode] = useState<string>('381');

    const maxLength = 15;

    const onPhoneNumChange = (
        value: string,
        data: CountryData | GenericObject,
        event: React.ChangeEvent<HTMLInputElement>,
        formattedValue: string,
    ) => {
        setDialCode(data.dialCode);
        setSpaceCount(formattedValue.split(' ').length - 1);
        setFieldValue(name, dialCode !== data.dialCode ? data.dialCode : formattedValue.replace(/\s/g, ''));
        setValueLength(formattedValue.replace(/\s/g, '').length);
    };

    const onBlur = (e: FocusEvent) => {
        // name is not defined on underlaying component, so explicit touched should be set
        setTouched({ ...touched, [name]: true });
    };

    return (
        <>
            <FormControl required={true}>
                <Field
                    as={PhoneInput}
                    id={id}
                    value={values[name]}
                    country={country}
                    countryCodeEditable={false}
                    specialLabel={specialLabel}
                    inputProps={{ maxLength: valueLength <= maxLength ? maxLength + spaceCount : valueLength }}
                    placeholder={''}
                    onChange={onPhoneNumChange}
                    onBlur={onBlur}
                    masks={{ rs: '.. ... ....' }}
                />

                {touched[name] && errors[name] ? (
                    <FormHelperText error={true}>
                        <>{errors[name]}</>
                    </FormHelperText>
                ) : null}
            </FormControl>
        </>
    );
};
export default PhoneInputField;
